export default __webpack_public_path__ + "static/media/sgdAcct.11d24fb3.png";